import React from "react";
import { useNavigate } from 'react-router-dom';
// Components
import Button from '../../../components/generics/Button';
// Assets
import successImg from 'img/success-img.svg';
import errorImg from 'img/error-img.svg';
import warningImg from 'img/question-img.svg';
// Interfaces
import { QuoteDownloadModalProps } from '../../interface';
// Styles
import { 
  ModalContainer, 
  IconContainer, 
  ModalTitle, 
  ModalMessage, 
  ButtonContainer 
} from './styles';

const QuoteDownloadModal: React.FC<QuoteDownloadModalProps> = ({ 
  type, 
  title, 
  message, 
  onClose, 
  showGridButton = false 
}) => {
  const navigate = useNavigate();

  const getIcon = () => {
    switch (type) {
      case 'success':
        return successImg;
      case 'error':
        return errorImg;
      case 'warning':
        return warningImg;
      default:
        return successImg;
    }
  };

  const handleGoToGrid = () => {
    onClose();
    navigate('/cotacoes-dashboard');
  };

  return (
    <ModalContainer>
      <IconContainer>
        <img src={getIcon()} alt={`${type}-icon`} width="64" height="64" />
      </IconContainer>
      
      <ModalTitle>
        {title}
      </ModalTitle>
      
      <ModalMessage>
        {message}
      </ModalMessage>
      
      <ButtonContainer>
        {showGridButton && (
          <Button
            label="Grid de cotações"
            onClick={handleGoToGrid}
            width={160}
            className="primary-button"
          />
        )}
        
        <Button
          label="Fechar"
          onClick={onClose}
          second={showGridButton}
          width={showGridButton ? 120 : 160}
          className={showGridButton ? "secondary-button" : "primary-button"}
        />
      </ButtonContainer>
    </ModalContainer>
  );
};

export default QuoteDownloadModal;
